import { render, staticRenderFns } from "./LinhaFornecimentoMsgAlert.vue?vue&type=template&id=1361f1c9&scoped=true"
import script from "./LinhaFornecimentoMsgAlert.vue?vue&type=script&lang=js"
export * from "./LinhaFornecimentoMsgAlert.vue?vue&type=script&lang=js"
import style0 from "./LinhaFornecimentoMsgAlert.vue?vue&type=style&index=0&id=1361f1c9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361f1c9",
  null
  
)

export default component.exports